export { LightboxWrapper } from './LightBoxWrapper';
